import React from "react";

import isEqual from "lodash/isEqual";
import PropTypes from "prop-types";
import Space from "shared/components/Space";
import { StepStore } from "shared/components/Tab";
import TabItem from "shared/components/TabBar/TabItem";

const Actions = ({ folder, selected, onSelect, step: { changeTab } }) => {
  return (
    <div className={"switch-row"}>
      {folder.map((item) => (
        <>
          <TabItem
            text={item.description}
            selected={isEqual(selected, item)}
            onClick={() => {
              changeTab(item.pageChunk);
              onSelect(item);
            }}
          />
          <Space h={14} />
        </>
      ))}
    </div>
  );
};

Actions.propTypes = {
  folder: PropTypes.arrayOf(
    PropTypes.shape({
      pageChunk: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    }),
  ).isRequired,
  step: PropTypes.shape({
    changeTab: PropTypes.func.isRequired,
  }).isRequired,
  selected: PropTypes.shape({
    pageChunk: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  }),
  onSelect: PropTypes.func.isRequired,
};

export default StepStore(Actions);
